type AddListingDataType = { [key: string]: any };

export const saveListingData = (listingId: string, data: any) => {
  const addListingData: string = localStorage.getItem('addListingData') || '[]';
  let parsedData: AddListingDataType[] = JSON.parse(addListingData);
  let existingListing: AddListingDataType | undefined = parsedData.find(
    (listing: AddListingDataType) => listing.id === listingId,
  );
  if (existingListing) {
    existingListing = {
      ...existingListing,
      data: { ...existingListing.data, ...data },
    };
    parsedData = parsedData
      .map((listing: AddListingDataType) =>
        listing.id === listingId ? existingListing : listing,
      )
      .filter(
        (listing): listing is AddListingDataType => listing !== undefined,
      );
    localStorage.setItem('addListingData', JSON.stringify(parsedData));
    return existingListing;
  } else {
    parsedData.push({ id: listingId, data });
    localStorage.setItem('addListingData', JSON.stringify(parsedData));
    return { id: listingId, data };
  }
};

export const deleteListingData = (listingId: string) => {
  const addListingData: string = localStorage.getItem('addListingData') || '[]';
  let parsedData: AddListingDataType[] = JSON.parse(addListingData);
  parsedData = parsedData.filter(
    (listing: AddListingDataType) => listing.id !== listingId,
  );
  localStorage.setItem('addListingData', JSON.stringify(parsedData));
};
